import { Vue, Component } from 'vue-property-decorator';
import { debounce as _debounce } from 'lodash';

import siteEquipmentsClient from '@/core/api/site-equipments-service';
import { SiteEquipmentsCustomerListItemDTO } from '@/../client-generator/generated-clients/siteEquipments';
import { LOADING_CONTENT } from '@/core/store/types/action-types';

import SiteEquipmentsListCardsComponent from './SiteEquipmentsListCardsComponent/SiteEquipmentsListCardsComponent.vue';

@Component({
  components: {
    SiteEquipmentsListCardsComponent,
  },
})
export default class SiteEquipmentsList extends Vue {
  isLoading = false;
  ss = '';
  searchString = '';

  allSiteEquipments: SiteEquipmentsCustomerListItemDTO[] = [];

  created() {
    this.handleSearch = _debounce(this.handleSearch, 500);
  }

  mounted(): void {
    this.loadSiteEquipments();
  }

  handleSearch(val) {
    this.searchString = val;
  }

  async loadSiteEquipments() {
    this.$store.dispatch(LOADING_CONTENT, true);

    try {
      this.allSiteEquipments = await siteEquipmentsClient.myList();
    } catch (error) {
      let messageError = 'error';

      switch (error.status) {
        case 401:
          messageError = this.$t('apiErrors.unauthorized').toString();
          break;
        case 403:
          messageError = this.$t('apiErrors.forbidden').toString();
          break;
        default:
          messageError = this.$t('apiErrors.serverError').toString();
      }

      this.$message.error(messageError);
    } finally {
      this.$store.dispatch(LOADING_CONTENT, false);
    }
  }

  get filteredSiteEquipments() {
    if (!this.searchString) return this.allSiteEquipments;

    return this.allSiteEquipments.filter((k) => {
      return (
        k.brandName?.toLowerCase().includes(this.searchString) ||
        k.description?.toLowerCase().includes(this.searchString) ||
        k.serialNumber?.toLowerCase().includes(this.searchString) ||
        k.model?.toLowerCase().includes(this.searchString)
      );
    });
  }
}
